import React, { memo, Fragment, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { NavLink } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import CategoryIcon from '@material-ui/icons/Category';
import AssignmentIcon from '@material-ui/icons/Assignment';
import JarIcon from '../assets/svgs/JarIcon';
import PiechartIcon from '../assets/svgs/PiechartIcon';
import ProfilePopover from './ProfilePopover';
import Avatar from '@material-ui/core/Avatar';
import { AuthContext } from '../context/auth.context';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(({ spacing, palette }) => ({
	drawer: {
		backgroundColor: palette.grey[900],
		height: '100%',
		paddingTop: spacing(1)
	},
	listItem: {
		justifyContent: 'center',
		padding: spacing(2, 4.5, 2, 3.5),
		color: palette.grey.light[10],
		'& svg': {
			fill: palette.grey.light[10]
		},
		'& hr': {
			backgroundColor: 'rgba(255, 255, 255, 0.08)'
		}
	},
	active: {
		color: '#fff',
		'& svg': {
			fill: '#fff'
		}
	},
	avatarButton: {
		margin: '0 auto'
	},
	avatar: {
		width: spacing(7),
		height: spacing(7)
	},
	expandIcon: {
		width: spacing(4),
		height: spacing(4),
		marginLeft: spacing(2)
	}
}));

function MobileSidebar({ drawerOpen, setDrawerOpen }) {
	const classes = useStyles();
	const [ anchorProfile, setAnchorProfile ] = useState(null);
	const currentUser = useContext(AuthContext);

	const toggleDrawer = open => event => {
		if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}
		setDrawerOpen(open);
	};

	const tabs = [
		{ label: 'Transactions', icon: <HomeIcon />, route: '/' },
		{ label: 'Categories', icon: <CategoryIcon />, route: '/categories' },
		{ label: 'Budgets', icon: <AssignmentIcon />, route: '/budgets' },
		{ label: 'Jars', icon: <JarIcon />, route: '/jars' },
		{ label: 'Reports', icon: <PiechartIcon />, route: '/reports' }
	];

	const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

	return (
		<Fragment>
			<ProfilePopover anchorEl={anchorProfile} setAnchorEl={setAnchorProfile} />
			<SwipeableDrawer
				disableBackdropTransition={!iOS}
				disableDiscovery={iOS}
				open={drawerOpen}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}>
				<div className={classes.drawer}>
					<div
						className={classes.list}
						role="presentation"
						onClick={toggleDrawer(false)}
						onKeyDown={toggleDrawer(false)}>
						<List>
							<ListItem
								button
								onClick={e => {
									setAnchorProfile(e.currentTarget);
									e.stopPropagation();
								}}
								className={classes.listItem}>
								<Avatar
									alt={currentUser.displayName}
									src={currentUser.photoURL}
									className={classes.avatar}
								/>
								<ExpandMoreIcon className={classes.expandIcon} />
							</ListItem>
							<Divider />
							{tabs.map((tab, i) => (
								<Fragment key={i}>
									<ListItem
										className={classes.listItem}
										button
										component={NavLink}
										exact
										activeClassName={classes.active}
										onClick={toggleDrawer(false)}
										to={tab.route}>
										<ListItemIcon>{tab.icon}</ListItemIcon>
										<ListItemText primary={tab.label} />
									</ListItem>
									{i < tabs.length - 1 && <Divider />}
								</Fragment>
							))}
						</List>
					</div>
				</div>
			</SwipeableDrawer>
		</Fragment>
	);
}
export default memo(MobileSidebar);
